<ng-container *transloco="let t; read: 'basket'">
  @if (vm$ | async; as vm) {
    <div class="componentContainer">
      <section class="xs12col componentHeader">
        <h1>{{t('admin.title')}}</h1>
      </section>
      <section class="oneCol">
        <div class="xs12col m6col">
          <div class="boxContainer">
            <div class="box">
              <h2 class="padding-bottom-medium">{{t('chooseCompany')}}</h2>
              <app-company-basket-dropdown></app-company-basket-dropdown>
            </div>
          </div>
        </div>
      </section>
      @if (offlineBasketItems) {
        @if (offlineBasketItems.length != 0) {
          <section class="oneCol">
            <div class="xs12col">
              <div class="boxContainer offlineBasket">
                <div class="box">
                  <h3 class="offlineBasketWarning">{{t('offlineBasketWarning')}}</h3>
                  <app-offline-basket
                    [isAdminView]="('Permissions.BasketItems.CreateGlobal' | permission)"
                    [currentCompany]="currentCompany$ | async"
                    (onReload)="reloadBasket()"
                    [offline]="false">
                  </app-offline-basket>
                </div>
              </div>
            </div>
          </section>
        }
      }
      <section class="oneCol">
        <div class="xs12col">
          <div class="boxContainer">
            <div class="box">
              <app-basket-grid
                [data]="vm.basketItems"
                [loading]="loading"
                [skip]="vm.gridState.skip"
                [pageSize]="vm.gridState.pageSize"
                [isAdminView]="true"
                (onReload)="reloadBasket()">
              </app-basket-grid>
            </div>
          </div>
        </div>
      </section>
    </div>
  }
</ng-container>